exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// ../core-js/modules/_object-pie.js
// module id = 532
// module chunks = 0